<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-warning">
            <h4 class="card-title">{{ isEditMode ? 'Edit Todo' : 'Add Todo' }}</h4>
            <p class="card-category">Complete todo details</p>
          </div>
          <div class="card-body">
            <form [formGroup]="todoForm" (ngSubmit)="submitForm()">
              <div class="row">
                <!-- Title -->
                <div class="col-md-6">
                  <mat-form-field class="w-100">
                    <mat-label>Title</mat-label>
                    <input matInput formControlName="title" placeholder="Enter title" />
                  </mat-form-field>
                </div>

                <!-- Due Date -->
                <div class="col-md-6">
                  <mat-form-field class="w-100">
                    <mat-label>Due Date</mat-label>
                    <input matInput [matDatepicker]="duePicker" formControlName="dueDate" placeholder="Choose date" />
                    <mat-datepicker-toggle matSuffix [for]="duePicker"></mat-datepicker-toggle>
                    <mat-datepicker #duePicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <!-- Description -->
                <div class="col-md-12">
                  <mat-form-field class="w-100">
                    <mat-label>Description</mat-label>
                    <textarea matInput rows="3" formControlName="description" placeholder="Enter description"></textarea>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <!-- Case -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Case</mat-label>
                    <mat-select formControlName="caseId">
                      <mat-option *ngFor="let c of cases" [value]="c.id">{{ c.caseNumber }}/{{ c.year }} - {{ c.client?.fullName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Client -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Client</mat-label>
                    <mat-select formControlName="clientId">
                      <mat-option *ngFor="let client of clients" [value]="client.id">{{ client.fullName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Diary -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Diary</mat-label>
                    <mat-select formControlName="diaryId">
                      <mat-option *ngFor="let diary of diaries" [value]="diary.id">{{ diary.hearingDate | date:'shortDate' }} - {{ diary.case?.caseNumber }}/{{ diary.case?.year }} - {{ diary.case?.client?.fullName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <!-- Completion Status (only in edit mode) -->
              <div class="row" *ngIf="isEditMode">
                <div class="col-md-6">
                  <mat-checkbox formControlName="isCompleted">Is Completed</mat-checkbox>
                </div>
                <div class="col-md-6" *ngIf="todoForm.get('isCompleted')?.value">
                  <mat-form-field class="w-100">
                    <mat-label>Completed At</mat-label>
                    <input matInput [matDatepicker]="completedPicker" formControlName="completedAt" placeholder="Completion date" />
                    <mat-datepicker-toggle matSuffix [for]="completedPicker"></mat-datepicker-toggle>
                    <mat-datepicker #completedPicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <!-- Sub-Todos Section -->
              <div class="row mt-4">
                <div class="col-md-12">
                  <h5 class="mb-3">Sub-Todos</h5>
                  
                  <!-- Add New Sub-Todo -->
                  <div class="d-flex gap-2 mb-3">
                    <input type="text" 
                           class="form-control" 
                           [(ngModel)]="newSubTodoDescription" 
                           [ngModelOptions]="{standalone: true}"
                           placeholder="Enter sub-todo description"
                           (keyup.enter)="addNewSubTodo()">
                    <button type="button" 
                            class="btn btn-sm btn-success" 
                            (click)="addNewSubTodo()">
                      <i class="material-icons" style="font-size: 18px;">add</i> Add
                    </button>
                  </div>

                  <!-- New Sub-Todos List (not yet saved) -->
                  <div *ngIf="newSubTodos.length > 0" class="mb-3">
                    <div *ngFor="let newSubTodo of newSubTodos; let i = index" 
                         class="d-flex align-items-center gap-2 mb-2 p-2 border rounded">
                      <i class="material-icons" style="color: #9e9e9e; font-size: 20px;">radio_button_unchecked</i>
                      <span class="flex-grow-1">{{ newSubTodo.description }}</span>
                      <button type="button" 
                              class="btn btn-sm btn-danger" 
                              (click)="removeNewSubTodo(i)">
                        <i class="material-icons" style="font-size: 18px;">delete</i>
                      </button>
                    </div>
                  </div>

                  <!-- Existing Sub-Todos List (in edit mode) -->
                  <div *ngIf="isEditMode && subTodos.length > 0" class="mb-3">
                    <div *ngFor="let subTodo of subTodos" 
                         class="d-flex align-items-center gap-2 mb-2 p-2 border rounded">
                      <i *ngIf="subTodo.isDone" 
                         class="material-icons" 
                         style="color: #4caf50; font-size: 20px; cursor: pointer;" 
                         (click)="uncheckSubTodo(subTodo.id)" 
                         title="Click to uncheck">check_circle</i>
                      <i *ngIf="!subTodo.isDone" 
                         class="material-icons" 
                         style="color: #9e9e9e; font-size: 20px; cursor: pointer;" 
                         (click)="checkSubTodo(subTodo.id)" 
                         title="Click to check">radio_button_unchecked</i>
                      <span class="flex-grow-1" [style.text-decoration]="subTodo.isDone ? 'line-through' : 'none'">
                        {{ subTodo.description || 'No description' }}
                      </span>
                      <button type="button" 
                              class="btn btn-sm btn-danger" 
                              (click)="deleteSubTodo(subTodo.id)">
                        <i class="material-icons" style="font-size: 18px;">delete</i>
                      </button>
                    </div>
                  </div>

                  <!-- Empty state -->
                  <div *ngIf="newSubTodos.length === 0 && (!isEditMode || subTodos.length === 0)" 
                       class="text-muted text-center py-3">
                    No sub-todos added yet
                  </div>
                </div>
              </div>

              <button mat-raised-button color="primary" type="submit" class="btn btn-primary pull-right" [disabled]="isSubmited" (click)="isSubmited = true">
                {{ isEditMode ? 'Update Todo' : 'Add Todo' }}
              </button>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
